import { useReference } from "../../../controllers/conductor";
import { MainWindow } from "../MainWindow";

export function Forms() {

    let states = useReference({ ready: false });

    return (<MainWindow currentTab="forms">
        { states.ready ? <SameDay /> : <LoadingScreen /> }
    </MainWindow>);
}

function SameDay() {
    return <div>Same day</div>;
}

function LoadingScreen() {
    return <div>Loading...</div>;
}